import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import SiteFooter from "../components/SiteFooter";

declare global { interface Window { IMP: any } }

const Global = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #f0ebe3; font-family: 'Malgun Gothic','Apple SD Gothic Neo',Arial,sans-serif; }
`;

/* ── 상담 상품 ────────────────────────────────────────── */
const PHONE_SERVICES = [
  { key: "종합운세",  price: 50000 },
  { key: "신년운세",  price: 30000 },
  { key: "연애운",    price: 30000 },
  { key: "결혼운",    price: 30000 },
  { key: "직업운",    price: 30000 },
  { key: "사업운",    price: 30000 },
  { key: "건강운",    price: 30000 },
  { key: "연애궁합",  price: 50000 },
  { key: "심층궁합",  price: 80000 },
];

const NAVER_URL  = "https://naver.me/xZjIiBpV";
const KAKAO_URL  = "https://place.map.kakao.com/2033969175";
const PHONE_NUM  = "010-4282-2377";
const IMP_CODE   = process.env.REACT_APP_IMP_CODE || "imp00000000";

export default function MainPage() {
  const navigate = useNavigate();
  const [openSection, setOpenSection] = useState<"phone"|"visit"|null>(null);
  const [selectedSvc, setSelectedSvc] = useState(PHONE_SERVICES[0].key);
  const [payResult, setPayResult] = useState<string>("");

  const toggleSection = (s: "phone"|"visit") =>
    setOpenSection(prev => prev === s ? null : s);

  const handlePhonePayment = () => {
    const svc = PHONE_SERVICES.find(s => s.key === selectedSvc)!;
    const merchantUid = `phone_${selectedSvc}_${Date.now()}`;
    if (typeof window.IMP === "undefined") {
      setPayResult("❌ 결제 모듈 로딩 중입니다. 잠시 후 다시 시도하세요.");
      return;
    }
    window.IMP.init(IMP_CODE);
    window.IMP.request_pay(
      {
        pg: "html5_inicis",
        pay_method: "card",
        merchant_uid: merchantUid,
        name: `우연 사주 전화상담 — ${svc.key}`,
        amount: svc.price,
        buyer_name: "",
        buyer_tel: "",
        buyer_email: "",
      },
      (rsp: any) => {
        if (rsp.success) {
          setPayResult(`✅ 결제 완료! ${PHONE_NUM}로 연락드리겠습니다.`);
        } else {
          setPayResult(`❌ 결제 실패: ${rsp.error_msg}`);
        }
      }
    );
  };

  return (
    <>
      <Global />
      <div style={{ maxWidth: 560, margin: "0 auto", padding: "40px 16px 80px" }}>

        {/* ── 헤더 ── */}
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <div style={{ fontSize: "2.8rem", marginBottom: 8 }}>🔮</div>
          <div style={{ fontSize: "1.6rem", fontWeight: 900, color: "#3d2b1f", letterSpacing: "-0.5px" }}>
            우연 사주
          </div>
          <div style={{ fontSize: "0.82rem", color: "#9c7b5a", marginTop: 6, letterSpacing: "0.3px" }}>
            정밀 명리학 기반 운세 분석
          </div>
        </div>

        {/* ── 섹션 1: 온라인 사주 (메일 수령) ── */}
        <div
          onClick={() => navigate("/client")}
          style={{
            background: "linear-gradient(135deg,#3d2b1f,#6b4c35)",
            borderRadius: 20, padding: "28px 24px",
            marginBottom: 14, cursor: "pointer",
            boxShadow: "0 8px 32px rgba(61,43,31,0.18)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
            <span style={{ fontSize: "1.6rem" }}>📱</span>
            <div>
              <div style={{ fontWeight: 900, color: "#fff", fontSize: "1.05rem" }}>온라인 사주</div>
              <div style={{ fontSize: "0.72rem", color: "#c9a882", marginTop: 2 }}>결제 후 이메일로 리포트 수령</div>
            </div>
            <div style={{ marginLeft: "auto", color: "#c9a882", fontSize: "1.1rem" }}>→</div>
          </div>
          <div style={{ fontSize: "0.83rem", color: "#e8d5bf", lineHeight: 1.75, marginBottom: 16 }}>
            우연사주의 명리학 분석 리포트를 이메일로 받아보세요.<br />
            종합운세 · 신년운세 · 연애궁합 · 재회운 · 결혼운 등 8가지 운세 제공.
          </div>
          <div style={{
            display: "inline-block", background: "#c09a6b", color: "#fff",
            borderRadius: 24, padding: "10px 24px",
            fontSize: "0.88rem", fontWeight: 800,
          }}>
            운세 선택하기 →
          </div>
        </div>

        {/* ── 섹션 1-B: 쿠키 사주 ── */}
        <div
          onClick={() => navigate("/quick")}
          style={{
            background: "linear-gradient(135deg,#4a2060,#7048a8)",
            borderRadius: 20, padding: "22px 24px",
            marginBottom: 14, cursor: "pointer",
            boxShadow: "0 8px 32px rgba(112,72,168,0.18)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
            <span style={{ fontSize: "1.6rem" }}>🍪</span>
            <div>
              <div style={{ fontWeight: 900, color: "#fff", fontSize: "1.05rem" }}>쿠키 사주</div>
              <div style={{ fontSize: "0.72rem", color: "#c9a8f0", marginTop: 2 }}>연애운 · 직장운 · 재물운 · 연애궁합</div>
            </div>
            <div style={{ marginLeft: "auto", color: "#c9a8f0", fontSize: "1.1rem" }}>→</div>
          </div>
          <div style={{ fontSize: "0.83rem", color: "#e0d0ff", lineHeight: 1.75, marginBottom: 14 }}>
            궁금한 운세 하나만 딱 골라서 확인하세요.<br />
            <strong style={{ color: "#fff" }}>1,000원</strong>으로 명리학으로 즉시 풀어드립니다.<br />
            연애궁합은 2,000원 (두 사람 사주 분석)
          </div>
          <div style={{
            display: "inline-block", background: "#9775fa", color: "#fff",
            borderRadius: 24, padding: "8px 20px",
            fontSize: "0.88rem", fontWeight: 800,
          }}>
            바로 확인하기 →
          </div>
        </div>

        {/* ── 섹션 1-C: 방문 상담 사주 ── */}
        <div
          onClick={() => navigate("/visit")}
          style={{
            background: "linear-gradient(135deg,#1a4a3a,#2d7a5f)",
            borderRadius: 20, padding: "22px 24px",
            marginBottom: 14, cursor: "pointer",
            boxShadow: "0 8px 32px rgba(29,122,95,0.18)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
            <span style={{ fontSize: "1.6rem" }}>🏠</span>
            <div>
              <div style={{ fontWeight: 900, color: "#fff", fontSize: "1.05rem" }}>방문 상담 사주</div>
              <div style={{ fontSize: "0.72rem", color: "#a8dfc8", marginTop: 2 }}>종합운세 · 연애궁합 · 결혼운 등 9가지</div>
            </div>
            <div style={{ marginLeft: "auto", color: "#a8dfc8", fontSize: "1.1rem" }}>→</div>
          </div>
          <div style={{ fontSize: "0.83rem", color: "#d0f0e4", lineHeight: 1.75, marginBottom: 14 }}>
            직접 방문하여 1:1 대면 상담을 받으세요.<br />
            상담 후 <strong style={{ color: "#fff" }}>명리학 분석 리포트</strong>를 이메일로 발송해드립니다.<br />
            결제는 방문 당일 현장에서 진행됩니다.
          </div>
          <div style={{
            display: "inline-block", background: "#2d9e74", color: "#fff",
            borderRadius: 24, padding: "8px 20px",
            fontSize: "0.88rem", fontWeight: 800,
          }}>
            방문 접수하기 →
          </div>
        </div>

        {/* ── 섹션 2: 전화상담예약 ── */}
        <div style={{
          background: "#fff", borderRadius: 20, border: "1.5px solid #e0d5c8",
          marginBottom: 14, overflow: "hidden",
          boxShadow: "0 4px 16px rgba(100,70,40,0.07)",
        }}>
          <button
            onClick={() => toggleSection("phone")}
            style={{
              width: "100%", background: "none", border: "none",
              padding: "22px 24px", cursor: "pointer",
              display: "flex", alignItems: "center", gap: 12,
            }}
          >
            <span style={{ fontSize: "1.6rem" }}>📞</span>
            <div style={{ textAlign: "left", flex: 1 }}>
              <div style={{ fontWeight: 900, color: "#3d2b1f", fontSize: "1.05rem" }}>전화 상담</div>
              <div style={{ fontSize: "0.72rem", color: "#9c7b5a", marginTop: 2 }}>
                전화 통화로 1:1 맞춤 상담
              </div>
            </div>
            <div style={{
              color: "#c09a6b", fontSize: "1.2rem",
              transform: openSection === "phone" ? "rotate(90deg)" : "none",
              transition: "transform 0.2s",
            }}>▶</div>
          </button>

          {openSection === "phone" && (
            <div style={{ padding: "0 24px 24px", borderTop: "1px solid #f0e8de" }}>

              {/* 전화하기 버튼 */}
              <a
                href={`tel:${PHONE_NUM.replace(/-/g, "")}`}
                style={{
                  display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                  background: "linear-gradient(135deg,#2f9e44,#40c057)",
                  color: "#fff", textDecoration: "none", borderRadius: 14,
                  padding: "14px", fontWeight: 800, fontSize: "1rem",
                  marginTop: 16, marginBottom: 20,
                  boxShadow: "0 4px 14px rgba(47,158,68,0.25)",
                }}
              >
                📞 &nbsp;{PHONE_NUM} 전화하기
              </a>

              {/* 결제하기 */}
              <div style={{ fontSize: "0.78rem", fontWeight: 700, color: "#7a6654", marginBottom: 10 }}>
                상담 예약 결제
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 14 }}>
                {PHONE_SERVICES.map(s => (
                  <button
                    key={s.key}
                    onClick={() => setSelectedSvc(s.key)}
                    style={{
                      padding: "10px 8px", borderRadius: 10, cursor: "pointer",
                      border: selectedSvc === s.key ? "2px solid #c09a6b" : "1.5px solid #e0d5c8",
                      background: selectedSvc === s.key ? "#faf0e6" : "#fff",
                      fontFamily: "inherit", textAlign: "left",
                    }}
                  >
                    <div style={{ fontSize: "0.82rem", fontWeight: 700, color: "#3d2b1f" }}>{s.key}</div>
                    <div style={{ fontSize: "0.75rem", color: "#c09a6b", marginTop: 2 }}>
                      {s.price.toLocaleString()}원
                    </div>
                  </button>
                ))}
              </div>

              <button
                onClick={handlePhonePayment}
                style={{
                  width: "100%", padding: "14px",
                  background: "linear-gradient(135deg,#c09a6b,#a07850)",
                  color: "#fff", border: "none", borderRadius: 14,
                  fontSize: "0.95rem", fontWeight: 800, cursor: "pointer",
                  boxShadow: "0 4px 14px rgba(192,154,107,0.3)", fontFamily: "inherit",
                }}
              >
                💳 &nbsp;{PHONE_SERVICES.find(s=>s.key===selectedSvc)?.price.toLocaleString()}원 결제하기
              </button>

              {payResult && (
                <div style={{
                  marginTop: 12, padding: "10px 14px",
                  background: payResult.startsWith("✅") ? "#ebfbee" : "#fff5f5",
                  borderRadius: 10, fontSize: "0.82rem", color: "#3d2b1f",
                  border: `1px solid ${payResult.startsWith("✅") ? "#8ce99a" : "#ffc9c9"}`,
                }}>
                  {payResult}
                </div>
              )}
            </div>
          )}
        </div>

        {/* ── 섹션 3: 방문상담예약 ── */}
        <div style={{
          background: "#fff", borderRadius: 20, border: "1.5px solid #e0d5c8",
          marginBottom: 14, overflow: "hidden",
          boxShadow: "0 4px 16px rgba(100,70,40,0.07)",
        }}>
          <button
            onClick={() => toggleSection("visit")}
            style={{
              width: "100%", background: "none", border: "none",
              padding: "22px 24px", cursor: "pointer",
              display: "flex", alignItems: "center", gap: 12,
            }}
          >
            <span style={{ fontSize: "1.6rem" }}>🏠</span>
            <div style={{ textAlign: "left", flex: 1 }}>
              <div style={{ fontWeight: 900, color: "#3d2b1f", fontSize: "1.05rem" }}>방문 상담 예약</div>
              <div style={{ fontSize: "0.72rem", color: "#9c7b5a", marginTop: 2 }}>
                직접 방문하여 1:1 대면 상담 · 결제는 현장에서
              </div>
            </div>
            <div style={{
              color: "#c09a6b", fontSize: "1.2rem",
              transform: openSection === "visit" ? "rotate(90deg)" : "none",
              transition: "transform 0.2s",
            }}>▶</div>
          </button>

          {openSection === "visit" && (
            <div style={{ padding: "0 24px 24px", borderTop: "1px solid #f0e8de" }}>
              <div style={{ fontSize: "0.78rem", color: "#9c7b5a", margin: "16px 0 14px", lineHeight: 1.7 }}>
                아래 플랫폼에서 원하는 날짜와 시간을 선택하여 예약하세요.<br />
                결제는 방문 당일 현장에서 진행됩니다.
              </div>

              <a
                href={NAVER_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                  background: "#03C75A", color: "#fff", textDecoration: "none",
                  borderRadius: 14, padding: "14px", fontWeight: 800, fontSize: "0.95rem",
                  marginBottom: 10, boxShadow: "0 4px 14px rgba(3,199,90,0.25)",
                }}
              >
                <span style={{ fontSize: "1.1rem" }}>🟢</span> 네이버에서 예약하기
              </a>

              <a
                href={KAKAO_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                  background: "#FEE500", color: "#3C1E1E", textDecoration: "none",
                  borderRadius: 14, padding: "14px", fontWeight: 800, fontSize: "0.95rem",
                  boxShadow: "0 4px 14px rgba(254,229,0,0.35)",
                }}
              >
                <span style={{ fontSize: "1.1rem" }}>💛</span> 카카오에서 예약하기
              </a>
            </div>
          )}
        </div>

        {/* ── 사업자 정보 푸터 ── */}
        <SiteFooter />

      </div>
    </>
  );
}
